module.exports = __webpack_public_path__ + "components/flag/static/square/fm-68e9649125e6c1bfddd927b3324a4db6.svg";